export default "__VITE_ASSET__CdU0YiEY__"